// UI string tables. Master role = English; assigned users = Gujarati.
const STR = {
  gu: {
    logout: "બહાર",
    greeting: (n) => `કેમ છો, ${n}`,
    dashHelp: "તમે નવો કાગળ વાંચવા કેમેરા બટન કે ફોટો પસંદ કરો બટન દબાવો. નીચે તમારા બધા કાગળ છે. લીલા એટલે જરૂરી, લાલ એટલે કચરો.",
    remRemember: (n) => `${n} કાગળની તારીખ યાદ રાખો`,
    remSpeak: (n, labels) => `તમારે ${n} કાગળની તારીખ યાદ રાખવાની છે. ${labels}`,
    langLabel: "ભાષા:",
    camera: "કેમેરા",
    upload: "ફોટો પસંદ કરો",
    files: "ફાઇલ / PDF",
    camError: "કેમેરા ચાલુ ન થયો. ફોટો પસંદ કરો બટન વાપરો.", camTakePhoto: "ફોટો લો",
    camPages: (n) => `${n} પાનાં લીધાં`, camRead: "વાંચો",
    myDocs: "મારા કાગળ",
    deleteConfirm: "આ કાગળ કાઢી નાખવો છે?",
    deletedToast: "કાગળ કાઢી નાખ્યો",
    emptyDocs: "હજી કોઈ કાગળ નથી. ઉપર બટન દબાવીને નવો કાગળ વાંચો.",
    scanningVoice: "કાગળ વાંચું છું, થોડી વાર થોભો.",
    scanErrToast: "કાગળ વાંચી ન શક્યો, સાફ ફોટો લો",
    scanErrVoice: "કાગળ વાંચી ન શક્યો. ફરી સાફ ફોટો લો.",
    others: "બીજા",
    // modal
    tabRead: "વાંચો", tabAsk: "પૂછો", tabReply: "જવાબ", tabShare: "મોકલો",
    important: "જરૂરી", junk: "કચરો",
    listen: "સાંભળો", slow: "ધીમે", repeat: "ફરી",
    whatToDo: "શું કરવું:", originalText: "મૂળ લખાણ",
    send: "મોકલો", del: "કાઢો",
    askEmpty: "આ કાગળ વિશે કંઈ પણ પૂછો.", askPlaceholder: "પ્રશ્ન લખો...",
    askVoice: "બોલીને પૂછો", askVoiceStop: "બોલવાનું બંધ કરો",
    replyGenerate: "જવાબ તૈયાર કરો", replyLabel: "જવાબ:", replyCopy: "જવાબ કોપી કરો",
    shareTitle: "સંબંધીને આ કાગળનો સાર મોકલો", noHelpers: "હજી કોઈ સંબંધી ઉમેર્યા નથી. નીચે નામ અને નંબર લખો.",
    addHelper: "નવો સંબંધી ઉમેરો", namePh: "નામ", phonePh: "ફોન નંબર (દેશ કોડ સાથે, જેમ કે 9198...)",
    add: "ઉમેરો", otherShare: "બીજી રીતે મોકલો",
    forwardTitle: "ફોટો અને અવાજ મોકલો", forwardBtn: "ફોટો + અવાજ મોકલો",
    emailBtn: "ઈમેલ", preparingMedia: "તૈયાર થાય છે...", forwardHint: "એક ટચમાં ફોટો અને અવાજ ક્લિપ મોકલો",
    copied: "કોપી થઈ ગયું", deleted: "કાઢી નાખ્યું",
    ansErr: "જવાબ ન મળ્યો", voiceErr: "સાંભળી ન શક્યો, ફરી પ્રયાસ કરો", micErr: "માઇક ચાલુ ન થયો",
    replyErr: "જવાબ તૈયાર ન થયો", sendErr: "મોકલી ન શકાયું",
    helperNeed: "નામ અને નંબર લખો", helperAdded: "સંબંધી ઉમેર્યા", helperErr: "ઉમેરી ન શકાયું",
    save: "કાગળ સાચવો", saveHint: "આ કાગળ રાખવો હોય તો સાચવો, નહીં તો કાઢી નાખો.", savedToast: "કાગળ સચવાયો", savedBadge: "સચવાયેલ",
    limitedTitle: "તમને ફક્ત YunusBol મળ્યું છે", limitedBody: "બધી સેવાઓ (AVLegal, urMEETai) માટે SP નો સંપર્ક કરો.",
  },
  en: {
    logout: "Logout",
    greeting: (n) => `Hello, ${n}`,
    dashHelp: "Press Camera or Choose Photo to read a new paper. Your documents are below. Green means important, red means junk.",
    remRemember: (n) => `Remember ${n} deadline${n > 1 ? "s" : ""}`,
    remSpeak: (n, labels) => `You have ${n} deadline${n > 1 ? "s" : ""} to remember. ${labels}`,
    langLabel: "Language:",
    camera: "Camera",
    upload: "Choose Photo",
    files: "Files / PDF",
    camError: "Camera did not start. Use the Choose Photo button.", camTakePhoto: "Take photo",
    camPages: (n) => `${n} page${n === 1 ? "" : "s"} taken`, camRead: "Read",
    myDocs: "My Documents",
    deleteConfirm: "Delete this document?",
    deletedToast: "Document deleted",
    emptyDocs: "No documents yet. Tap a button above to read a new paper.",
    scanningVoice: "Reading the paper, please wait.",
    scanErrToast: "Could not read the paper, take a clearer photo",
    scanErrVoice: "Could not read the paper. Please take a clearer photo.",
    others: "Others",
    tabRead: "Read", tabAsk: "Ask", tabReply: "Reply", tabShare: "Share",
    important: "Important", junk: "Junk",
    listen: "Listen", slow: "Slow", repeat: "Repeat",
    whatToDo: "What to do:", originalText: "Original text",
    send: "Send", del: "Delete",
    askEmpty: "Ask anything about this paper.", askPlaceholder: "Type a question...",
    askVoice: "Ask by voice", askVoiceStop: "Stop speaking",
    replyGenerate: "Prepare a reply", replyLabel: "Reply:", replyCopy: "Copy reply",
    shareTitle: "Send this paper's summary to a family helper", noHelpers: "No helpers yet. Add a name and number below.",
    addHelper: "Add a helper", namePh: "Name", phonePh: "Phone number (with country code, e.g. 9198...)",
    add: "Add", otherShare: "Share another way",
    forwardTitle: "Send photo & voice", forwardBtn: "Send photo + voice",
    emailBtn: "Email", preparingMedia: "Getting ready...", forwardHint: "One tap — sends the photo and voice clip",
    copied: "Copied", deleted: "Deleted",
    ansErr: "No answer received", voiceErr: "Couldn't hear you, please try again", micErr: "Microphone didn't start",
    replyErr: "Couldn't prepare a reply", sendErr: "Couldn't send",
    helperNeed: "Enter a name and number", helperAdded: "Helper added", helperErr: "Couldn't add",
    save: "Save document", saveHint: "Save this paper to keep it, or delete it.", savedToast: "Document saved", savedBadge: "Saved",
    limitedTitle: "You have access to YunusBol only", limitedBody: "For all features (AVLegal, urMEETai) contact SP.",
  },
  ar: {
    logout: "خروج",
    greeting: (n) => `مرحبا، ${n}`,
    dashHelp: "اضغط على الكاميرا أو اختر صورة أو ملف لقراءة ورقة جديدة. مستنداتك في الأسفل. الأخضر مهم والأحمر غير مهم.",
    remRemember: (n) => `تذكّر ${n} من المواعيد النهائية`,
    remSpeak: (n, labels) => `لديك ${n} من المواعيد النهائية يجب تذكّرها. ${labels}`,
    langLabel: "اللغة:",
    camera: "كاميرا",
    upload: "اختر صورة",
    files: "ملفات / PDF",
    camError: "لم تعمل الكاميرا. استخدم زر اختر صورة.", camTakePhoto: "التقط صورة",
    camPages: (n) => `تم التقاط ${n} صفحة`, camRead: "اقرأ",
    myDocs: "مستنداتي",
    deleteConfirm: "هل تريد حذف هذا المستند؟",
    deletedToast: "تم حذف المستند",
    emptyDocs: "لا توجد مستندات بعد. اضغط زرًا في الأعلى لقراءة ورقة جديدة.",
    scanningVoice: "أقرأ الورقة، انتظر قليلاً.",
    scanErrToast: "تعذّرت قراءة الورقة، التقط صورة أوضح",
    scanErrVoice: "تعذّرت قراءة الورقة. التقط صورة أوضح من فضلك.",
    others: "أخرى",
    tabRead: "اقرأ", tabAsk: "اسأل", tabReply: "رد", tabShare: "مشاركة",
    important: "مهم", junk: "غير مهم",
    listen: "استمع", slow: "ببطء", repeat: "كرر",
    whatToDo: "ماذا تفعل:", originalText: "النص الأصلي",
    send: "إرسال", del: "حذف",
    askEmpty: "اسأل أي شيء عن هذه الورقة.", askPlaceholder: "اكتب سؤالاً...",
    askVoice: "اسأل بصوتك", askVoiceStop: "أوقف التحدث",
    replyGenerate: "جهّز ردًا", replyLabel: "الرد:", replyCopy: "انسخ الرد",
    shareTitle: "أرسل ملخص هذه الورقة إلى أحد المساعدين", noHelpers: "لا يوجد مساعدون بعد. أضف اسمًا ورقمًا أدناه.",
    addHelper: "أضف مساعدًا", namePh: "الاسم", phonePh: "رقم الهاتف (مع رمز الدولة، مثل 9198...)",
    add: "أضف", otherShare: "شارك بطريقة أخرى",
    forwardTitle: "أرسل الصورة والصوت", forwardBtn: "أرسل الصورة + الصوت",
    emailBtn: "بريد إلكتروني", preparingMedia: "جارٍ التحضير...", forwardHint: "بلمسة واحدة — يرسل الصورة والمقطع الصوتي",
    copied: "تم النسخ", deleted: "تم الحذف",
    ansErr: "لم يصل رد", voiceErr: "لم أسمعك، حاول مرة أخرى", micErr: "لم يبدأ الميكروفون",
    replyErr: "تعذّر تجهيز الرد", sendErr: "تعذّر الإرسال",
    helperNeed: "أدخل اسمًا ورقمًا", helperAdded: "تمت إضافة المساعد", helperErr: "تعذّرت الإضافة",
    save: "احفظ المستند", saveHint: "احفظ هذه الورقة للاحتفاظ بها، أو احذفها.", savedToast: "تم حفظ المستند", savedBadge: "محفوظ",
    limitedTitle: "لديك صلاحية YunusBol فقط", limitedBody: "للوصول إلى كل الميزات (AVLegal و urMEETai) تواصل مع SP.",
  },
};

export const isRtl = (uiLang) => uiLang === "ar";

export const makeT = (uiLang) => {
  const table = STR[uiLang] || STR.gu;
  return (key, ...args) => {
    const v = table[key] ?? STR.gu[key];
    return typeof v === "function" ? v(...args) : v;
  };
};
